import type { AppConfig } from '#/config/types/AppConfig';

export async function horizonRegisterServiceWorker(config: AppConfig) {
  const swUrl = `/sw.js?version=${config.idealist.versionNumber}&cdnUri=${config.idealist.cdnUri ?? ''}&horizon=true`;

  try {
    const registration = await navigator.serviceWorker.register(swUrl);
    // oxlint-disable-next-line no-console
    console.log(
      'ServiceWorker registration successful with scope: ',
      registration.scope,
    );
  } catch (error) {
    // oxlint-disable-next-line no-console
    console.log('ServiceWorker registration failed: ', error);
  }
}
